<!-- 点位组： 主页 -->
<template>
    <div>
        <div>
            <el-row>
                <div class="left-justifying"><h3>点位组</h3></div>
                <div class="right-justifying">
                    <el-button type="info" plain size="small" @click="toAdd" v-if="addBtnExisted">
                        <i class="fa fa-plus-circle">
                        </i> 新建
                    </el-button>
                    <el-button type="info" plain size="small" @click="saveAdd" v-if="saveAddBtnExisted">
                        <i class="fa fa-save">
                        </i> 保存
                    </el-button>
                    <el-button type="info" plain size="small" @click="cancelAdd" v-if="cancelAddBtnExisted">
                        <i class="fa fa-undo">
                        </i> 取消
                    </el-button>
                    <el-button type="info" plain size="small" @click="toEdit" v-if="editBtnExisted">
                        <i class="fa fa-pencil">
                        </i> 修改
                    </el-button>
                    <el-button type="info" plain size="small" @click="saveEdit" v-if="saveEditBtnExisted">
                        <i class="fa fa-save">
                        </i> 保存
                    </el-button>
                    <el-button type="info" plain size="small" @click="cancelEdit" v-if="cancelEditBtnExisted">
                        <i class="fa fa-undo">
                        </i> 取消
                    </el-button>
                    <el-button type="info" plain size="small" @click="toInvalidate" v-if="invalidateBtnExisted">
                        <i class="fa fa-times">
                        </i> 停用
                    </el-button>
                    <el-button type="info" plain size="small" @click="toRevalidate" v-if="revalidateBtnExisted">
                        <i class="fa fa-check">
                        </i> 启用
                    </el-button>
                    <el-button type="info" plain size="small" @click="toRemove" v-if="deleteBtnExisted">
                        <i class="fa fa-times">
                        </i> 删除
                    </el-button>
                </div>
            </el-row>
        </div>
        <div class="panel">
            <div class="panel-body">
                <el-row>
                    <div class="advanced-search-location">

                    </div>
                    <div>
                        <el-tabs v-model="activeTabName" :before-leave="tabsBeforeLeave">
                            <el-tab-pane  v-for="tab in tabs" :key="tab.name" :label="tab.label" :name="tab.name" >
                                <keep-alive>
                                    <router-view :name="tab.name">
                                    </router-view>
                                </keep-alive>
                            </el-tab-pane>
                        </el-tabs>
                    </div>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>

    import {
        EVENT_KEY$$DETAILS$$INVALIDATE,
        EVENT_KEY$$DETAILS$$REMOVE,
        EVENT_KEY$$DETAILS$$REVALIDATE,
        EVENT_KEY$$DETAILS$$SAVE_ADD,
        EVENT_KEY$$DETAILS$$SAVE_EDIT,
        EVENT_KEY$$INDEX$$SET_CURRENT_ROW_ID,
        EVENT_KEY$$INDEX$$SET_DETAILS_FORM_MODEL,
        OPERATION_ADD,
        OPERATION_EDIT,
        OPERATION_SHOW,
        PATH_DETAILS,
        PATH_PAGE,
        PERMISSION_ADD,
        PERMISSION_DELETE,
        PERMISSION_EDIT,
        TAB_LABEL_DETAILS,
        TAB_LABEL_PAGE,
        TAB_NAME_DETAILS,
        TAB_NAME_PAGE,
    } from './common';
    import eventBus from "@/util/common/event-bus";

    export default {
        name: "point-group",
        data() {
            return {
                currentRowId: null,
                detailsFormModel: null,
                activeTabName: 'page',
                tabs: [{
                    label: TAB_LABEL_PAGE,
                    name: TAB_NAME_PAGE,
                }, {
                    label: TAB_LABEL_DETAILS,
                    name: TAB_NAME_DETAILS,
                }],

                eventKeyIds: {},
            };
        },
        computed: {
            addBtnExisted() {
                return this.activeTabName === TAB_NAME_PAGE && this.hasPermission(PERMISSION_ADD);
            },
            saveAddBtnExisted() {
                return this.activeTabName === TAB_NAME_DETAILS && this.$route.path === PATH_DETAILS &&
                    (this.$route.query.operation == null || this.$route.query.operation === OPERATION_ADD) &&
                    this.hasPermission(PERMISSION_ADD);
            },
            cancelAddBtnExisted() {
                return this.activeTabName === TAB_NAME_DETAILS && this.$route.path === PATH_DETAILS &&
                    (this.$route.query.operation == null || this.$route.query.operation === OPERATION_ADD);
            },
            editBtnExisted() {
                return this.activeTabName === TAB_NAME_DETAILS && this.$route.path === PATH_DETAILS &&
                    (this.$route.query.operation === OPERATION_SHOW) &&
                    this.hasPermission(PERMISSION_EDIT);
            },
            saveEditBtnExisted() {
                return this.activeTabName === TAB_NAME_DETAILS && this.$route.path === PATH_DETAILS &&
                    (this.$route.query.operation === OPERATION_EDIT) &&
                    this.hasPermission(PERMISSION_EDIT);
            },
            cancelEditBtnExisted() {
                return this.activeTabName === TAB_NAME_DETAILS && this.$route.path === PATH_DETAILS &&
                    this.$route.query.operation === OPERATION_EDIT;
            },
            invalidateBtnExisted() {
                return this.activeTabName === TAB_NAME_DETAILS && this.$route.path === PATH_DETAILS &&
                    (this.$route.query.operation === OPERATION_SHOW) &&
                    (this.detailsFormModel != null && String(this.detailsFormModel.status) === '1') &&
                    this.hasPermission(PERMISSION_EDIT);
            },
            revalidateBtnExisted() {
                return this.activeTabName === TAB_NAME_DETAILS && this.$route.path === PATH_DETAILS &&
                    (this.$route.query.operation === OPERATION_SHOW) &&
                    (this.detailsFormModel != null && String(this.detailsFormModel.status) === '0') &&
                    this.hasPermission(PERMISSION_EDIT);
            },
            deleteBtnExisted() {
                return this.activeTabName === TAB_NAME_DETAILS && this.$route.path === PATH_DETAILS &&
                    this.$route.query.operation === OPERATION_SHOW &&
                    this.hasPermission(PERMISSION_DELETE);
            },
        },
        watch: {
            '$route': {
                immediate: true,
                handler() {
                    this.initActiveTabName();
                }
            },
        },
        methods: {
            setCurrentRowId(currentRowId) {
                this.currentRowId = currentRowId;
            },
            setDetailsFormModel(model) {
                this.detailsFormModel = model;
            },
            initActiveTabName() {
                if (this.$route.path === PATH_PAGE && this.activeTabName !== TAB_NAME_PAGE) {
                    this.activeTabName = TAB_NAME_PAGE;
                }
                if (this.$route.path === PATH_DETAILS && this.activeTabName !== TAB_NAME_DETAILS) {
                    this.activeTabName = TAB_NAME_DETAILS;
                    this.currentRowId = this.$route.query.id;
                }
            },
            tabsBeforeLeave(tabName) {
                if (tabName === TAB_NAME_PAGE && this.$route.path !== PATH_PAGE) {
                    this.$router.push(PATH_PAGE);
                } else if (tabName === TAB_NAME_DETAILS && this.$route.path !== PATH_DETAILS) {
                    this.$router.push({path: PATH_DETAILS, query: {operation: OPERATION_SHOW, id: this.currentRowId}});
                }
            },
            toAdd() {
                this.$router.push({path: PATH_DETAILS, query: {operation: OPERATION_ADD}});
            },
            saveAdd() {
                eventBus.trigger(EVENT_KEY$$DETAILS$$SAVE_ADD);
            },
            cancelAdd() {
                this.$router.push(PATH_PAGE);
            },
            toEdit() {
                this.$router.push({path: PATH_DETAILS, query: {operation: OPERATION_EDIT, id: this.currentRowId}});
            },
            saveEdit() {
                eventBus.trigger(EVENT_KEY$$DETAILS$$SAVE_EDIT);
            },
            cancelEdit() {
                this.$router.push({path: PATH_DETAILS, query: {operation: OPERATION_SHOW, id: this.currentRowId}});
            },
            toInvalidate() {
                eventBus.trigger(EVENT_KEY$$DETAILS$$INVALIDATE);
            },
            toRevalidate() {
                eventBus.trigger(EVENT_KEY$$DETAILS$$REVALIDATE);
            },
            toRemove() {
                eventBus.trigger(EVENT_KEY$$DETAILS$$REMOVE);
            },
        },
        mounted() {
            this.eventKeyIds[EVENT_KEY$$INDEX$$SET_CURRENT_ROW_ID] =
                eventBus.bind(EVENT_KEY$$INDEX$$SET_CURRENT_ROW_ID, {
                    next: (currentRowId) => {this.setCurrentRowId(currentRowId);}
                });
            this.eventKeyIds[EVENT_KEY$$INDEX$$SET_DETAILS_FORM_MODEL] =
                eventBus.bind(EVENT_KEY$$INDEX$$SET_DETAILS_FORM_MODEL, {
                    next: (model) => {this.setDetailsFormModel(model);}
                });
        },
        beforeDestroy() {
            eventBus.unbind(EVENT_KEY$$INDEX$$SET_CURRENT_ROW_ID);
            eventBus.unbind(EVENT_KEY$$INDEX$$SET_DETAILS_FORM_MODEL);
        },
    }
</script>

<style scoped>

</style>
